import { db } from "../firebase";

export async function createUserData(
  name: string,
  dogName: string,
  age: string,
  sex: string,
  breed: string,
  houseNo: string,
  villageNo: string,
  lane: string,
  road: string,
  subDistrict: string,
  district: string,
  province: string,
  zipcode: string,
  tel: string,
  email: string
): Promise<any> {
  db.collection("users")
    .doc(email)
    .set({
      name: name,
      dogName: dogName,
      age: age,
      sex: sex,
      breed: breed,
      houseNo: houseNo,
      villageNo: villageNo,
      lane: lane,
      road: road,
      subDistrict: subDistrict,
      district: district,
      province: province,
      zipcode: zipcode,
      tel: tel,
      email: email,
    });
}
